// Top-of-app banner voor gebruikers die de signup-flow zijn begonnen maar nog
// niet afgerond. Linkt terug naar `/signup/<lastStep>` zodat ze verder kunnen
// vanaf waar ze ophielden.
//
// Toont alleen wanneer:
//   - `OnboardingStatus` op CompagnyMeta bestaat (gebruiker is in nieuwe flow)
//   - `OnboardingStatus.completed === false`
//   - Niet gedismissed in deze sessie (sessionStorage flag)
//
// Bestaande orgs zonder OnboardingStatus zien deze banner niet — die krijgen
// eventueel de TOCProgressBanner als hun TOC incomplete is.
//
// Spec: docs/features/onboarding-flow.md (T31).

import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'

import useSettings from '../../hooks/Settings'

const STORAGE_KEY = 'onboarding_resume_dismissed'

const readDismissed = () => {
    try { return sessionStorage.getItem(STORAGE_KEY) === '1' } catch { return false }
}

const OnboardingResumeBanner = () => {

    const onboardingStatus = useSettings().onboardingStatus
    const history = useHistory()
    const [dismissed, setDismissed] = useState(readDismissed)

    const inProgress = onboardingStatus
        && onboardingStatus.completed === false
        && !!onboardingStatus.lastStep

    if (!inProgress || dismissed) return null

    const lastStep = onboardingStatus.lastStep

    const handleContinue = () => {
        history.push(`/signup/${lastStep}`)
    }

    const handleDismiss = () => {
        try { sessionStorage.setItem(STORAGE_KEY, '1') } catch {}
        setDismissed(true)
    }

    return (
        <div className="onboarding-resume-banner" role="status">
            <span className="onboarding-resume-banner-text">
                Je hebt je signup nog niet afgerond. Wil je verder vanaf stap {lastStep}?
            </span>
            <button
                type="button"
                className="onboarding-resume-banner-button-primary"
                onClick={handleContinue}
            >
                Verder gaan
                <ArrowForwardOutlinedIcon style={{ fontSize: 16, marginLeft: 4, verticalAlign: 'text-bottom' }} />
            </button>
            <button
                type="button"
                className="onboarding-resume-banner-button-secondary"
                onClick={handleDismiss}
            >
                Later
            </button>
        </div>
    )

}

export default OnboardingResumeBanner
